<template lang="pug">
    .page-not-found
        Error(:message="$t('Page Not Found')")
</template>

<script>

import store from '@/store'

import Auth from '@/components/Auth'
import Error from '@/components/Error'

export default {
    name: 'PageNotFound',
    components: {
        Error,
        Auth
    },
    beforeRouteEnter (to, from, next) {
        const auth = _.get(store, 'state.auth')
        if (! auth.token) next('/')
        else next()
    }
}
</script>

<style lang="sass" scoped>
    .page-not-found
        height: 100%
        :deep()
            .title
                margin-top: 0
</style>
